import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";

function Component({ component }: ComponentProps) {
	return <>{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}</>;
}

export default Component;
